module.exports = __webpack_public_path__ + "img/PAI_Landing-Page_Desktop_21.e7023b26.jpg";